import React from 'react';
import {Button, Col, Label, Row} from 'reactstrap';
import {AvGroup} from 'availity-reactstrap-validation';
import PropTypes from 'prop-types';
import AvField from "../../shared/component/form/AvField";
import Translate from "../../shared/language/Translate";
import FormSection from "../../shared/component/form/FormSection";

import GeneralUtils from "../../shared/utils/GeneralUtils";
import {
    BARCODE_LENGTH,
    BARCODE_TYPE,
    PRODUCT_UNIT,
    TILL_PRICE_CALCULATION_METHOD,
    TILL_PRICE_ITEM_CALCULATION_METHOD,
    VAT_RATES
} from "../../shared/utils/Constants";
import {InputNumber} from "primereact/inputnumber";
import {Checkbox} from "primereact/checkbox";
import DepartmentService from "../../shared/service/DepartmentService";
import TaxService from "../../shared/service/TaxService";
import {toast} from "react-toastify";
import ProductService from "../../shared/service/ProductService";
import SupplierService from "../../shared/service/SupplierService";
import NumberFormat from 'react-number-format';
import '../../shared/styles/SettingsPage.css';
import StockActivityService from "../../shared/service/StockActivityService";
import {AutoComplete} from "primereact/autocomplete";
import MerchantBranchSettingsService from "../../shared/service/MerchantBranchSettingsService";
import ModalConfirm from "../../shared/component/dialog/ModalConfirm";
import PurchaseOrderItemConflictDialog, {
    CONFLICT_SELECT_NONE
} from "../../shared/component/dialog/PurchaseOrderItemConflictDialog";
import MerchantUserService from "../../shared/service/MerchantUserService";
import DateInput from "../../shared/component/form/DateInput";
import {
    getPurchaseOrderFieldHighlight,
    isPurchaseOrderFieldUp
} from "./PurchaseOrderHighlightUtils";
import PurchaseOrderItemStatusBadge from "./PurchaseOrderItemStatusBadge";
import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import PurchaseOrderService from "../../shared/service/PurchaseOrderService";

dayjs.extend(customParseFormat);

const defaultProduct = {
    id: '',
    name: '',
    status: 'ACTIVE',
    barcode: '',
    minStock: null,
    maxStock: null,
    currentStock: null,
    stockOperation: '',
    oldPrice: null,
    stockOperationReason: '',
    barcodeType: "NORMAL",
    barcodeDigit: null,
    codeLength: null

};

export default class PurchaseOrderItemSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            product: Object.assign({}, defaultProduct),
            productDetailsSaveButtonRender: true,
            disabledFields: false,
            taxList: [],
            departmentList: [],
            isOpenFromItem: true,
            displayShowStatusConfirmDialog: false,
            currentStock: null,
            supplierList: [],
            purchaseOrderStatus: false,
            filteredProducts: [],
            tillPriceCalculationMethod: "",
            printQueueTillUserBssId: null,
            tillUserList: [],
            isEditMode: false,
            showConflictDialog: false,
            conflictingItems: [],
            conflictMessage: "",
            pendingSaveAction: null,
            pendingSaveType: null
        }
        this.departmentService = new DepartmentService();
        this.taxService = new TaxService();
        this.productService = new ProductService();
        this.supplierService = new SupplierService();
        this.stockActivityService = new StockActivityService();
        this.merchantBranchSettingsService = new MerchantBranchSettingsService();
        this.merchantUserService = new MerchantUserService();
        this.purchaseOrderService = new PurchaseOrderService();
    }

    componentDidMount() {
        this.taxService.findAll().then(response => this.setState({taxList: response}));
        this.departmentService.findAll().then(response => this.setState({departmentList: response}));
        this.supplierService.findAll().then(response => this.setState({supplierList: response}));
        this.merchantUserService.getTillUsers(localStorage.getItem("merchantBranchId")).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                this.setState({
                    tillUserList: response,
                });
            }

        });


    }

    setData = (data, purchaseOrderStatus, invoiceType, isOpenFromItem, tillPriceCalculationMethod, printQueueTillUserBssId, isEditMode) => {
        let product = Object.assign({}, data);
        if (product.itemBssId != null) {
            this.stockActivityService.getCurrentStockOfProduct(product.itemBssId)
                .then((response) => {
                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            currentStock: response,
                        });
                    } else {
                        this.setState({
                            currentStock: null,
                        });
                    }
                });
        } else {
            this.setState({
                currentStock: null,
            });
        }

        let productDetailsSaveButtonRender = true;
        if (purchaseOrderStatus == "CLOSED") {
            productDetailsSaveButtonRender = false;
        } else if (purchaseOrderStatus == "PARTIAL_CLOSED" && product.itemClosed) {
            productDetailsSaveButtonRender = false;
        }
        if (product.status == "PASSIVE") {
            productDetailsSaveButtonRender = false;
        }

        // Edit mode'da fieldlar disabled olacak ama Save ve Close butonları aktif kalacak
        const disabledFieldsValue = purchaseOrderStatus === "CLOSED" || (purchaseOrderStatus === "PARTIAL_CLOSED" && product.itemClosed) || product.status == "PASSIVE" || isEditMode;

        this.setState({
            product: product,
            printQueueTillUserBssId: printQueueTillUserBssId,
            tillPriceCalculationMethod: tillPriceCalculationMethod,
            invoiceType: invoiceType,
            purchaseOrderStatus: purchaseOrderStatus,
            isOpenFromItem: isOpenFromItem,
            productDetailsSaveButtonRender: productDetailsSaveButtonRender,
            disabledFields: disabledFieldsValue,
            isEditMode: isEditMode || false,
        }, () => {
            this.focusBarcodeInput();
            product = this.props.calculateFields(product);
            this.setState({product: product});
        });

    }

    focusBarcodeInput = () => {
        try {
            setTimeout(() => {
                try {
                    let input = null;

                    // Hangi barcode input focus olacak?
                     if (

                        !this.state.disabledFields &&
                        !this.state.product.newCodedProduct &&
                        this.barcodeRef2
                    ) {
                        input = this.barcodeRef2;
                    }

                    if (input) {
                        // Focus ver
                        input.focus();

                        // Caret’i sona taşı (küçük micro-delay ile)
                        setTimeout(() => {
                            try {
                                const len = input.value?.length || 0;
                                input.setSelectionRange(len, len);
                            } catch (innerErr) {
                                console.error("Caret positioning error:", innerErr);
                            }
                        }, 10);
                    }
                } catch (err) {
                    console.error("Barcode focus error:", err);
                }
            }, 200); // render + DOM update + repaint için güvenli gecikme
        } catch (outerErr) {
            console.error("Unexpected error in focusBarcodeInput:", outerErr);
        }
    };


    render() {
        return (
            <div className="p-col-12">


                <ModalConfirm header='Warning' ok='OK' onOkClick={this.props.deleteItemData}
                              onCancelClick={() => this.setState({displayShowStatusConfirmDialog: false})}
                              show={this.state.displayShowStatusConfirmDialog}
                              message={this.state.noticeResponse}/>

                <PurchaseOrderItemConflictDialog
                    show={this.state.showConflictDialog}
                    conflictingItems={this.state.conflictingItems}
                    message={this.state.conflictMessage}
                    onSaveClick={this.handleConflictResolution}
                    onCancelClick={this.handleConflictCancel}
                />

                {this.renderProductDetails()}

                {this.renderPriceCalculator()}


                <div className="settings-page__actions settings-page__actions--equal-height settings-page__actions--inline settings-page__actions--dialog-footer">
                    <div className="settings-page__actions-group">
                        {this.state.productDetailsSaveButtonRender && !this.state.isEditMode && this.state.purchaseOrderStatus !== "CLOSED" && (
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--save"
                                onClick={() => this.updateOrderItem("save")}
                            >
                                <Translate contentKey="entity.action.add">Save</Translate>
                            </Button>
                        )}

                        {this.state.productDetailsSaveButtonRender && !this.state.isEditMode && (
                            <Button
                                color="outline-primary"
                                className="settings-page__btn--save"
                                onClick={() => this.updateOrderItem("saveandnext")}
                            >
                                <Translate contentKey="entity.action.add">Save & Next</Translate>
                            </Button>
                        )}
                    </div>

                    <div className="settings-page__actions-group settings-page__actions-group--end">
                        <Button
                            color="outline-primary"
                            className="settings-page__btn--action"
                            onClick={() => {
                                const obj1 = {...this.state.product};
                                this.props.openNextItem(obj1);
                            }}
                        >
                            <Translate contentKey="entity.action.add">Next</Translate>
                        </Button>

                        {this.state.productDetailsSaveButtonRender && !this.state.isEditMode &&  this.state.product.status == "ACTIVE" && (
                            <Button
                                color="outline-danger"
                                className="settings-page__btn--delete"
                                onClick={() => {
                                    const obj1 = {...this.state.product, status: "PASSIVE"};
                                    if (this.state.isOpenFromItem) {
                                        this.props.updatePurchaseOrderItemAndNext(obj1);
                                    } else {
                                        this.props.updatePurchaseOrderItemAndNextUnmatched(obj1);
                                    }
                                }}
                            >
                                <Translate contentKey="entity.action.add">Ignore</Translate>
                            </Button>
                        )}

                        { this.state.purchaseOrderStatus != "CLOSED" && this.state.purchaseOrderStatus != "PARTIAL_CLOSED" && !this.state.isEditMode &&  this.state.product.status == "PASSIVE" && (
                                <Button
                                    color="outline-primary"
                                    className="settings-page__btn--edit"
                                    onClick={() => {
                                        const obj1 = {...this.state.product, status: "ACTIVE"};
                                        if (this.state.isOpenFromItem) {
                                            this.props.updatePurchaseOrderItemAndNext(obj1);
                                        } else {
                                            this.props.updatePurchaseOrderItemAndNextUnmatched(obj1);
                                        }
                                    }}
                                >
                                    <Translate contentKey="entity.action.add">Unignore</Translate>
                                </Button>
                        )}

                        <Button color="outline-primary" className="settings-page__btn--cancel settings-page__btn--close"
                                onClick={this.props.closeDisplayDialog}>
                            <Translate contentKey="entity.action.add">Close</Translate>
                        </Button>
                    </div>
                </div>


            </div>
        );
    }

    renderComparisonArrow(product, field, value) {
        const color = getPurchaseOrderFieldHighlight(product, field, value);
        if (!color) {
            return null;
        }

        return (
            <span
                style={{
                    marginLeft: '6px',
                    marginRight: '2px',
                    color,
                    fontWeight: 'bold'
                }}
            >
                {isPurchaseOrderFieldUp(color) ? '▲' : '▼'}
            </span>
        );
    }

    renderReadOnly(label, value, options = {}) {
        let displayValue;

        if (options.isCurrency) {
            const num = Number(value);
            displayValue = !isNaN(num) ? `£${num.toFixed(2)}` : '£0.00';
        } else {
            if (value === null || value === undefined || value === '' || value === 'null' || value === 'undefined') {
                displayValue = '-';
            } else {
                displayValue = value;
            }
        }

        const comparisonArrow = options.comparisonField
            ? this.renderComparisonArrow(this.state.product, options.comparisonField, value)
            : null;

        return (
            <div style={{marginBottom: 8}}>
                {/* Label bold */}
                <div
                    style={{
                        fontSize: 12,
                        fontWeight: 700,
                        color: '#1982D9',
                        marginBottom: 4, // label ile value arasına boşluk
                    }}
                >
                    {label}
                    {comparisonArrow}
                </div>
                {/* Value normal */}
                <div style={{fontWeight: 400}}>{displayValue}</div>
            </div>
        );
    }


    renderProductDetails() {
        return (
            <FormSection title="Product">
                <Row>
                    {/* SOL TARAF – EDITABLE FORM */}
                    <Col md="8">
                        <Row className="po-product-barcode-name-row">

                            { (
                                <Col md="4">
                                    <AvGroup>
                                        <Label className="po-product-field-label" for="barcode">
                                            <Translate contentKey="purchaseOrderItem.barcode">Barcode</Translate>
                                            <span style={{color: 'red'}}> (*)</span>
                                        </Label>
                                        <div className="po-product-barcode-input-row">
                                            <AvField
                                                type="text"
                                                name="barcode"
                                                id="barcode"
                                                innerRef={(el) => (this.barcodeRef2 = el)}
                                                disabled={
                                                    this.state.disabledFields ||
                                                    this.state.product.newCodedProduct
                                                }
                                                className="form-control"
                                                style={{flex: 1, minWidth: 0}}
                                                value={this.state.product.barcode}
                                                onKeyDown={this._handleKeyDown}
                                                onChange={this.__handleChange}
                                            />
                                            <Button
                                                type="button"
                                                color="link"
                                                disabled={
                                                    this.state.disabledFields ||
                                                    this.state.product.newCodedProduct ||
                                                    this.state.isEditMode
                                                }
                                                style={{
                                                    padding: '4px',
                                                    border: 'none',
                                                    background: 'transparent',
                                                    boxShadow: 'none',
                                                    minWidth: '22px',
                                                    width: '22px',
                                                    flexShrink: 0,
                                                    marginTop: 0
                                                }}
                                                onClick={this.handleBarcodeSearchClick}
                                                title="Restore Item"
                                            >
                                                <i className="pi pi-search" style={{fontSize: '0.8rem'}}/>
                                            </Button>
                                            <span className="po-product-barcode-input-row__badge">
                                                {this.renderStatusBadge()}
                                            </span>
                                        </div>
                                    </AvGroup>
                                </Col>
                            )}

                            {/* Item Name */}
                            <Col md="8">
                                <AvGroup>
                                    <Label className="po-product-field-label" for="itemName">
                                        <Translate contentKey="purchaseOrderItem.itemName">Name</Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>

                                    <AutoComplete inputId="itemName"
                                                  value={this.state.product.itemName}
                                                  suggestions={
                                                      this.state.filteredProducts
                                                  }
                                                  dropdown={(() => {
                                                      const barcode = this.state.product.barcode?.toString() || "";
                                                      return !barcode || barcode.length < 8;
                                                  })()}

                                                  onFocus={(e) => {
                                                      const query = this.state.product.itemName || "";
                                                      this.searchProduct({query});
                                                  }}
                                                  onBlur={() => {
                                                      setTimeout(() => {
                                                          this.setState({filteredProducts: []});
                                                      }, 500);
                                                  }}
                                                  completeMethod={this.searchProduct}
                                                  itemTemplate={(item) => {
                                                      if (item.id === -1) {
                                                          return (
                                                              <span style={{color: "red", fontWeight: "bold"}}>
                                                            <i className="pi pi-plus-circle"
                                                               style={{marginRight: "5px"}}/>
                                                                  {item.longname}
                                                        </span>
                                                          );
                                                      }
                                                      return <span>{item.longname}</span>;
                                                  }}
                                                  name="itemName"
                                                  field="longname"
                                                  disabled={this.state.disabledFields }
                                                  onChange={(e) => {
                                                      let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
                                                      let product = this.state.product;

                                                      this.setState({product: product});
                                                      if (!GeneralUtils.isNullOrEmpty(e.value?.id)) {
                                                          if (e.value?.id == -1) {
                                                              let product = this.state.product;
                                                              product["barcodeIsSearched"] = true;
                                                              product["newCodedProduct"] = true;
                                                              product["itemBssId"] = null;
                                                              product["oldPrice"] = null;
                                                              product["currentBoxPrice"] = null;
                                                              product["currentBoxSize"] = null;
                                                              product["currentUnitCost"] = null;
                                                              product["status"] = "ACTIVE";
                                                              this.setState({
                                                                  product: product,
                                                                  currentStock: null
                                                              });
                                                              this.generateNextBarcode();
                                                              this.getDefaultData();
                                                          } else {
                                                              let product = this.state.product;
                                                              product["itemName"] = value;
                                                              this.setState({product: product});
                                                              this.convertToDto(e.value);
                                                          }

                                                      } else {
                                                          product["itemName"] = value;
                                                          this.setState({product});
                                                      }
                                                  }}


                                    />


                                </AvGroup>
                            </Col>

                            {/* Item Size + Unit + Barcode Fields */}

                        </Row>

                        <Row>
                            <Col md="4">
                                <div style={{display: 'flex', gap: 10}}>
                                    <div style={{flex: 1}}>
                                        <AvGroup>
                                            <Label>
                                                <Translate contentKey="purchaseOrderItem.itemSize">
                                                    Item Size
                                                </Translate>
                                                <span style={{color: 'red'}}> (*)</span>
                                            </Label>
                                            <AvField
                                                type="number"
                                                name="itemSize"
                                                disabled={
                                                    this.state.disabledFields
                                                }
                                                className="form-control"
                                                value={this.state.product.itemSize}
                                                onChange={this.__handleChange}
                                            />
                                        </AvGroup>
                                    </div>

                                    <div style={{flex: 1}}>
                                        <AvGroup>
                                            <Label>
                                                <Translate contentKey="purchaseOrderItem.itemUnitMeasure">
                                                    Item Unit
                                                </Translate>
                                                <span style={{color: 'red'}}> (*)</span>
                                            </Label>
                                            <AvField
                                                type="select"
                                                className="form-control"
                                                name="itemUnitMeasure"
                                                disabled={
                                                    this.state.disabledFields
                                                }
                                                value={this.state.product.itemUnitMeasure}
                                                onChange={this.__handleChange}
                                            >
                                                {PRODUCT_UNIT.map((el) => (
                                                    <option key={el.value} value={el.value}>
                                                        {el.name}
                                                    </option>
                                                ))}
                                            </AvField>
                                        </AvGroup>
                                    </div>


                                </div>
                            </Col>
                            <Col md="4">
                                <AvGroup>
                                    <Label>
                                        <Translate contentKey="contactManagement.mobilePhone">
                                            Department
                                        </Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>
                                    <AvField
                                        type="select"
                                        name="departmentId"
                                        className="form-control"
                                        disabled={this.state.disabledFields}
                                        value={this.state.product.departmentId}
                                        onChange={this.__handleChange}
                                    >
                                        <option value=""/>
                                        {this.state.departmentList.map((el) => (
                                            <option key={el.id} value={el.id}>
                                                {el.name}
                                            </option>
                                        ))}
                                    </AvField>
                                </AvGroup>
                            </Col>

                            <Col md="4">
                                <AvGroup>
                                    <Label>
                                        <Translate contentKey="purchaseOrderItem.taxRate">
                                            Vat
                                        </Translate>
                                        <span style={{color: 'red'}}> (*)</span>
                                    </Label>
                                    <AvField
                                        type="select"
                                        name="taxRate"
                                        className="form-control"
                                        disabled={this.state.disabledFields}
                                        value={this.state.product.taxRate}
                                        onChange={this.__handleChange}
                                    >
                                        <option value=""/>
                                        {VAT_RATES.map((el) => (
                                            <option key={el.value} value={el.value}>
                                                {el.name}
                                            </option>
                                        ))}
                                    </AvField>
                                </AvGroup>
                            </Col>
                            <Col md="4">
                                {this.renderBarcodeFields()}
                            </Col>


                        </Row>
                    </Col>

                    {/* SAĞ TARAF – READ ONLY PANEL */}
                    <Col md="4">
                        <div
                            style={{
                                background: '#f8f9fa',
                                padding: 16,
                                borderRadius: 8,
                                border: '1px solid #e0e0e0'
                            }}
                        >

                            {this.renderReadOnly(
                                'Original Description',
                                this.state.product.orjDescription
                            )}

                            {(this.state.invoiceType === "UPLOAD" || this.state.invoiceType === "CSV") &&
                                this.renderReadOnly(
                                    'Product Code',
                                    this.state.product.productCode
                                )}

                            {this.state.invoiceType === "CSV" &&
                                this.renderReadOnly(
                                    'Import Warning',
                                    this.state.product.importWarning
                                )}


                        </div>
                        <div className="settings-page__toolbar settings-page__toolbar--equal-height settings-page__toolbar--start"
                             style={{marginTop: '5px'}}>
                            {this.state.productDetailsSaveButtonRender &&  this.state.product.barcodeIsSearched && !GeneralUtils.isNullOrEmpty(this.state.product.itemBssId) &&
                                <Button
                                    color="outline-primary"
                                    className="settings-page__btn--edit"
                                    disabled={this.state.isEditMode}
                                    onClick={() => {
                                        let product = {...this.state.product};
                                        product["barcodeIsSearched"] = false;
                                        this.setState({product}, () => {
                                            this.findByBarcode();
                                        });

                                    }}
                                >
                                    <Translate contentKey="entity.action.add">Restore Item</Translate>
                                </Button>
                            }
                            {this.state.productDetailsSaveButtonRender &&  this.state.product.barcodeIsSearched && !GeneralUtils.isNullOrEmpty(this.state.product.itemBssId) && !GeneralUtils.isNullOrEmpty(this.state.product.orjDescription) &&
                                <Button
                                    type="button"
                                    color="outline-primary"
                                    className="settings-page__btn--action"
                                    disabled={this.state.disabledFields || this.state.product.newCodedProduct || this.state.isEditMode}
                                    onClick={this.handleResetItem}
                                >
                                    <Translate contentKey="entity.action.add">Reset Item</Translate>
                                </Button>
                            }
                        </div>
                    </Col>
                </Row>
            </FormSection>
        );
    }


    renderStatusBadge() {
        return <PurchaseOrderItemStatusBadge item={this.state?.product} inline/>;
    }


    renderBarcodeFields() {
        const {product, disabledFields} = this.state;
        const barcodeLength = product.barcode?.toString().length ?? 0;

        // Eğer 12 veya daha fazla karakter varsa Barcode Type ve Code Length göster
        if (barcodeLength >= 12) {
            return (
                <div style={{display: 'flex', gap: 10}}>
                    <div style={{flex: 1}}>
                        <AvGroup>
                            <Label>
                                <Translate contentKey="producttradingName">Barcode Type</Translate>
                            </Label>
                            <AvField
                                type="select"
                                className="form-control"
                                name="barcodeType"
                                disabled={disabledFields}
                                value={product.barcodeType}
                                onChange={this.__handleChange}
                            >
                                {BARCODE_TYPE.map(el => (
                                    <option value={el.value} key={el.value}>{el.name}</option>
                                ))}
                            </AvField>
                        </AvGroup>
                    </div>

                    {(product.barcodeType === "PRICE" || product.barcodeType === "WEIGHT") && (
                        <div style={{flex: 1}}>
                            <AvGroup>
                                <Label>
                                    <Translate contentKey="producttradingName">Code Length</Translate>
                                </Label>
                                <AvField
                                    type="select"
                                    className="form-control"
                                    name="codeLength"
                                    disabled={disabledFields}
                                    value={product.codeLength}
                                    onChange={this.__handleChange}
                                >
                                    <option value=""/>
                                    {BARCODE_LENGTH.map(el => (
                                        <option value={el.value} key={el.value}>{el.name}</option>
                                    ))}
                                </AvField>
                            </AvGroup>
                        </div>
                    )}
                </div>
            );
        }

        // Eğer 1-4 karakter varsa Weighable checkbox göster
        if (barcodeLength > 0 && barcodeLength < 5) {
            return (
                <div style={{display: 'flex', gap: 10}}>
                    <div style={{flex: 1}}>
                        <AvGroup>
                            <Label>
                                <Translate contentKey="productfirstName">Weighable</Translate>
                            </Label>
                            <Checkbox
                                onChange={(e) => this.setChecked("weighable", e.checked)}
                                name="weighable"
                                disabled={disabledFields}
                                value={product.weighable}
                                checked={product.weighable}
                            />
                        </AvGroup>
                    </div>
                </div>
            );
        }

        return null;
    }


    renderPriceCalculator() {
        const {product, disabledFields, tillUserList, tillPriceCalculationMethod} = this.state;

        return (
            <>
                <FormSection title="Cost & Pricing">
                    <Row>
                        {/* SOL TARAF – EDITABLE */}
                        <Col md="8">
                            <Row>
                                {/* Item Price Calculator */}
                                <Col md="4">
                                    <AvGroup>
                                        <Label>
                                            <Translate contentKey="productfirstName">Item Price Calculator</Translate>
                                        </Label>
                                        <AvField
                                            type="select"
                                            className="form-control"
                                            name="tillPriceCalculationMethod"
                                            disabled={disabledFields}
                                            value={product.tillPriceCalculationMethod}
                                            onChange={this.__handleChange}
                                        >
                                            <option value="">Select</option>
                                            {TILL_PRICE_ITEM_CALCULATION_METHOD.map(el => (
                                                <option key={el.value} value={el.value}>{el.name}</option>
                                            ))}
                                        </AvField>
                                    </AvGroup>
                                </Col>

                                {/* Item Till User */}
                                <Col md="4">
                                    <AvGroup>
                                        <Label>
                                            <Translate contentKey="contactManagement.mobilePhone">Item Till
                                                User</Translate>
                                        </Label>
                                        <AvField
                                            type="select"
                                            className="form-control"
                                            name="printQueueTillUserBssId"
                                            disabled={disabledFields}
                                            value={product.printQueueTillUserBssId}
                                            onChange={this.__handleChange}
                                        >
                                            <option value="">Select</option>
                                            {tillUserList.map(el => (
                                                <option key={el.bssId} value={el.bssId}>{el.name}</option>
                                            ))}
                                        </AvField>
                                    </AvGroup>
                                </Col>
                            </Row>

                            <Row>
                                {/* Total Cost */}
                                <Col md="4">
                                    <AvGroup>
                                        <Label>
                                            <span style={{color: 'blue'}}>Total Cost</span>
                                            <span style={{color: 'red'}}> (*)</span>
                                        </Label>
                                        <NumberFormat
                                            value={product.totalPrice}
                                            className="number-format-input"
                                            thousandSeparator
                                            decimalScale={2}
                                            fixedDecimalScale
                                            prefix="£"
                                            disabled={disabledFields}
                                            onValueChange={(values) => this.__handleChange({
                                                target: {
                                                    name: 'totalPrice',
                                                    value: values.value
                                                }
                                            })}
                                        />
                                    </AvGroup>
                                </Col>

                                {/* Profit Margin */}
                                <Col md="4">
                                    <AvGroup>
                                        <Label>
                                            <span style={{color: 'blue'}}>Profit Margin</span>
                                            <span style={{color: 'red'}}> (*)</span>
                                        </Label>
                                        <AvField
                                            type="number"
                                            name="profitMargin"
                                            className="form-control"
                                            step="1"
                                            onKeyDown={(e) => [".", ",", "e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                            disabled={disabledFields}
                                            value={product.profitMargin}
                                            onChange={this.__handleChange}
                                        />
                                    </AvGroup>
                                </Col>

                                {/* Sale Price */}
                                <Col md="4">
                                    <AvGroup>
                                        <Label>
                                            <span style={{color: 'blue'}}>Sale Price</span>
                                            {this.renderComparisonArrow(product, 'salePrice', product.salePrice)}
                                            <span style={{color: 'red'}}> (*)</span>
                                            {!GeneralUtils.isNullOrEmpty(this.state.product.priceMark) &&
                                                <span
                                                    style={{color: 'blue'}}>(PM: &nbsp;£{this.state.product.priceMark})</span>
                                            }
                                        </Label>
                                        <NumberFormat
                                            value={product.salePrice}
                                            className="number-format-input"
                                            thousandSeparator
                                            decimalScale={2}
                                            fixedDecimalScale
                                            prefix="£"
                                            disabled={disabledFields}
                                            onValueChange={(values) =>
                                                this.__handleChangePrice({
                                                    target: {name: 'salePrice', value: values.value},
                                                    isManual: this.userTyping
                                                })
                                            }
                                            onKeyDown={() => (this.userTyping = true)}
                                            onBlur={() => (this.userTyping = false)}
                                        />
                                    </AvGroup>
                                </Col>
                            </Row>

                            <Row>
                                {/* Delivery Qty */}
                                <Col md="4">
                                    <AvGroup>
                                        <Label>
                                            <span style={{color: 'blue'}}>Delivery Qty</span>
                                            <span style={{color: 'red'}}> (*)</span>
                                        </Label>
                                        <AvField
                                            type="number"
                                            name="deliveryQuantity"
                                            className="form-control"
                                            disabled={disabledFields}
                                            value={product.deliveryQuantity}
                                            onChange={this.__handleChange}
                                        />
                                    </AvGroup>
                                </Col>

                                {/* Box Qty */}
                                <Col md="4">
                                    <AvGroup>
                                        <Label>
                                            <span style={{color: 'blue'}}>Box Qty</span>
                                            <span style={{color: 'red'}}> (*)</span>
                                        </Label>
                                        <AvField
                                            type="number"
                                            name="boxSize"
                                            className="form-control"
                                            disabled={disabledFields}
                                            value={product.boxSize}
                                            onChange={this.__handleChange}
                                        />
                                    </AvGroup>
                                </Col>
                            </Row>

                            <Row>
                                {/* Min Stock */}
                                <Col md="4">
                                    <AvGroup>
                                        <Label>Min Stock</Label>
                                        <InputNumber
                                            name="minStock"
                                            value={product.minStock}
                                            disabled={disabledFields}
                                            onChange={this.__handleChange}
                                            className="w-100"
                                        />
                                    </AvGroup>
                                </Col>

                                {/* Max Stock */}
                                <Col md="4">
                                    <AvGroup>
                                        <Label>Max Stock</Label>
                                        <InputNumber
                                            name="maxStock"
                                            value={product.maxStock}
                                            disabled={disabledFields}
                                            onChange={this.__handleChange}
                                            className="w-100"
                                        />
                                    </AvGroup>
                                </Col>
                                <Col md="4">
                                    <AvGroup>
                                        <Label for="barcodeType">
                                            <Translate contentKey="producttradingName">Expiry Date</Translate>
                                        </Label>
                                        <DateInput
                                            name="expiryDate"
                                            onChange={this.__handleChange}
                                            format={"DD/MM/YYYY"}
                                            disabled={this.state.disabledFields}
                                            value={this.state.product.expiryDate}
                                        />


                                    </AvGroup>
                                </Col>
                            </Row>
                        </Col>

                        {/* SAĞ TARAF – READ ONLY */}
                        <Col md="4">
                            <div style={{
                                background: '#f8f9fa',
                                padding: 16,
                                borderRadius: 8,
                                border: '1px solid #e0e0e0'
                            }}>

                                {/* 1️⃣ En üst: Current Price (tek başına) */}
                                <Row>
                                    <Col md="6">
                                        {this.renderReadOnly('Current Price', product.oldPrice, {isCurrency: true})}
                                    </Col>
                                </Row>
                                {/* 3️⃣ Recommended Price & Actual Margin */}
                                <Row>
                                    <Col md="6">
                                        {this.renderReadOnly(
                                            'Rec. Price',
                                            product.recommendedSalePrice,
                                            {isCurrency: true, comparisonField: 'recommendedSalePrice'}
                                        )}
                                    </Col>
                                    <Col md="6">
                                        {this.renderReadOnly('Actual Margin', product.actualMargin)}
                                    </Col>
                                </Row>
                                {/* 2️⃣ Unit Profit & Total Profit */}
                                <Row>
                                    <Col md="6">
                                        {this.renderReadOnly('Unit Profit', product.profit, {isCurrency: true})}
                                    </Col>
                                    <Col md="6">
                                        {this.renderReadOnly(
                                            'Total Profit',
                                            (product.profit || 0) *
                                            (product.deliveryQuantity || 0) *
                                            (product.boxSize || 0),
                                            {isCurrency: true}
                                        )}
                                    </Col>
                                </Row>


                                {/* 4️⃣ Current Box Cost (solda) & Box Cost */}
                                <Row>
                                    <Col md="6">
                                        {this.renderReadOnly('Cur. Box Cost', product.currentBoxPrice, {isCurrency: true})}
                                    </Col>
                                    <Col md="6">
                                        {this.renderReadOnly('Box Cost', product.boxPrice, {isCurrency: true})}
                                    </Col>
                                </Row>

                                {/* 5️⃣ Current Unit Cost (solda) & Unit Cost */}
                                <Row>
                                    <Col md="6">
                                        {this.renderReadOnly('Cur. Unit Cost', product.currentUnitCost, {isCurrency: true})}
                                    </Col>
                                    <Col md="6">
                                        {this.renderReadOnly('Unit Cost', product.unitCost, {
                                            isCurrency: true,
                                            comparisonField: 'unitCost'
                                        })}
                                    </Col>
                                </Row>

                                {/* 6️⃣ Current Stock (solda) & New Stock */}
                                <Row>
                                    <Col md="6">
                                        {this.renderReadOnly('Current Stock', this.state.currentStock)}
                                    </Col>
                                    <Col md="6">
                                        {this.renderReadOnly(
                                            'New Stock',
                                            (product.deliveryQuantity || 0) * (product.boxSize || 0)
                                        )}
                                    </Col>
                                </Row>

                                {/* 7️⃣ En alt: Invoice bilgileri */}
                                <Row>
                                    <Col md="6">
                                        {this.renderReadOnly(
                                            'Invoice Price Calc.',
                                            TILL_PRICE_CALCULATION_METHOD.find(
                                                x => x.value === this.state.tillPriceCalculationMethod
                                            )?.name ?? '-'
                                        )}
                                    </Col>
                                    <Col md="6">
                                        {this.renderReadOnly(
                                            'Invoice Till User',
                                            this.state.tillUserList.find(
                                                x => x.bssId === this.state.printQueueTillUserBssId
                                            )?.name ?? '-'
                                        )}
                                    </Col>
                                </Row>


                            </div>
                        </Col>
                    </Row>
                </FormSection>
            </>
        );
    }


    setChecked = (name, value) => {
        let product = this.state.product;
        product[name] = value;
        this.setState({product: product});
    }

    setExpiryDate = (data) => {
        if (!GeneralUtils.isNullOrEmpty(data.expiryDate) && data.expiryDate !== 'Invalid Date') {
            let parsedDate = dayjs(data.expiryDate, "DD/MM/YYYY", true);
            if (!parsedDate.isValid()) {
                parsedDate = dayjs(data.expiryDate);
            }
            data['expiryDate'] = parsedDate.isValid()
                ? parsedDate.format("YYYY-MM-DDT00:00:00")
                : null;
        }
        return data;
    }
    checkConflictsAndUpdate = (obj1, save) => {
        if (GeneralUtils.isNullOrEmpty(obj1?.id) || GeneralUtils.isNullOrEmpty(obj1?.productCode)) {
            this.executeUpdate(obj1, save);
            return;
        }
        this.purchaseOrderService.checkConflicts(obj1).then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && !GeneralUtils.isNullOrEmpty(response.type)) {
                // Error occurred, proceed with normal update
                this.executeUpdate(obj1, save);
                return;
            }

            if (response && response.hasConflict && response.conflictingItems && response.conflictingItems.length > 0) {
                // Conflicts found, show dialog
                this.setState({
                    showConflictDialog: true,
                    conflictingItems: response.conflictingItems,
                    conflictMessage: response.message || "These items conflict with the same barcode but different product codes. Please select one to keep.",
                    pendingSaveAction: obj1,
                    pendingSaveType: save
                });
            } else {
                // No conflicts, proceed with normal update
                this.executeUpdate(obj1, save);
            }
        }).catch(error => {
            // Error checking conflicts, proceed with normal update
            console.error("Error checking conflicts:", error);
            this.executeUpdate(obj1, save);
        });
    };

    executeUpdate = (obj1, save) => {
        if (save === "save") {
            this.props.updatePurchaseOrderItem(obj1);
        } else if (this.state.isOpenFromItem) {
            this.props.updatePurchaseOrderItemAndNext(obj1);
        } else {
            this.props.updatePurchaseOrderItemAndNextUnmatched(obj1);
        }
    };

    handleConflictResolution = (selectedItemId) => {
        const { pendingSaveAction, pendingSaveType } = this.state;
        
        if (!pendingSaveAction) {
            this.setState({ showConflictDialog: false });
            return;
        }

        // Resolve conflict and update (pass 0 to API when user chose "None" for backend compatibility)
        const apiSelectedId = selectedItemId === CONFLICT_SELECT_NONE ? 0 : selectedItemId;
        this.purchaseOrderService.resolveConflictAndUpdate(pendingSaveAction, apiSelectedId)
            .then(response => {
                if (!GeneralUtils.isNullOrEmpty(response) && !GeneralUtils.isNullOrEmpty(response.type)) {
                    toast.error("Error resolving conflict");
                    this.setState({ showConflictDialog: false });
                    return;
                }

                this.setState({ showConflictDialog: false });
                if (selectedItemId === CONFLICT_SELECT_NONE) {
                    if (this.props.refreshOrderAndClose) this.props.refreshOrderAndClose();
                    else this.executeUpdate(pendingSaveAction, pendingSaveType);
                } else if (selectedItemId == pendingSaveAction.id) {
                    this.executeUpdate(pendingSaveAction, pendingSaveType);
                } else {
                    if (this.props.refreshOrderAndClose) this.props.refreshOrderAndClose();
                    else this.executeUpdate(pendingSaveAction, pendingSaveType);
                }
            })
            .catch(error => {
                console.error("Error resolving conflict:", error);
                toast.error("Error resolving conflict");
                this.setState({ showConflictDialog: false });
            });
    };

    handleConflictCancel = () => {
        this.setState({
            showConflictDialog: false,
            conflictingItems: [],
            conflictMessage: "",
            pendingSaveAction: null,
            pendingSaveType: null
        });
    };

    updateOrderItem = (save) => {
        if (this.state.invoiceType == "MANUAL_ENTRY" || this.state.invoiceType == "CSV") {
            if (GeneralUtils.isNullOrEmpty(this.state.product.deliveryQuantity)) {
                return toast.warn("Please fill the Delivery Qty field");
            } else if (this.state.product.totalPrice === null || this.state.product.totalPrice === undefined || this.state.product.totalPrice === '') {
                return toast.warn("Please fill the Total Price field");
            } else if (GeneralUtils.isNullOrEmpty(this.state.product.salePrice)) {
                return toast.warn("Please fill the Sale Price field");
            } else if (this.state.product.barcode != null && !GeneralUtils.isNullOrEmpty(this.state.product.barcodeType) && this.state.product.barcodeType != "NORMAL" && this.state.product.barcode.length >= 12 && GeneralUtils.isNullOrEmpty(this.state.product.codeLength)) {
                return toast.warn("Please fill the Code Length");
            } else {
                let product = this.state.product;
                let obj1 = {...product};
                obj1 = this.setExpiryDate(obj1);
                this.checkConflictsAndUpdate(obj1, save);
            }
        } else {
            if (this.state.invoiceType == "UPLOAD") {
                if (GeneralUtils.isNullOrEmpty(this.state.product.itemName)) {
                    return toast.warn("Please fill the Item name field");
                } else if (GeneralUtils.isNullOrEmpty(this.state.product.barcode)) {
                    return toast.warn("Please fill the Barcode field");
                } else if (GeneralUtils.isNullOrEmpty(this.state.product.deliveryQuantity)) {
                    return toast.warn("Please fill the Delivery Qty field");
                } else if (this.state.product.totalPrice === null || this.state.product.totalPrice === undefined || this.state.product.totalPrice === '') {
                    return toast.warn("Please fill the Total Cost field");
                } else if (GeneralUtils.isNullOrEmpty(this.state.product.salePrice) || this.state.product.salePrice == 0) {
                    return toast.warn("Please fill the Sale Price field");
                } else if (GeneralUtils.isNullOrEmpty(this.state.product.departmentId)) {
                    return toast.warn("Please select department");
                } else if (this.state.product.taxRate == null) {
                    return toast.warn("Please fill the Tax Rate field");
                } else if (this.state.product.barcode != null && !GeneralUtils.isNullOrEmpty(this.state.product.barcodeType) && this.state.product.barcodeType != "NORMAL" && this.state.product.barcode.length >= 12 && GeneralUtils.isNullOrEmpty(this.state.product.codeLength)) {
                    return toast.warn("Please fill the Code Length");
                } else {

                    if (this.state.product.itemBssId == null && this.state.product.barcodeIsSearched && this.state.product.newCodedProduct) {
                        this.saveProduct().then(() => {
                            let product = this.state.product;
                            let obj1 = {...product};
                            obj1 = this.setExpiryDate(obj1);
                            this.checkConflictsAndUpdate(obj1, save);
                        });
                    } else {
                        let product = this.state.product;
                        let obj1 = {...product};
                        obj1 = this.setExpiryDate(obj1);
                        this.checkConflictsAndUpdate(obj1, save);
                    }


                }


            }

        }


    }

    _handleKeyDown = (e) => {
        if (e.target.name === 'barcode') {
            const allowedKeys = ['Backspace', 'Tab', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', 'Home', 'End', 'Enter'];
            const isDigit = e.key.length === 1 && /[0-9]/.test(e.key);
            const isAllowedSpecial = allowedKeys.includes(e.key);
            const isShortcut = e.ctrlKey || e.metaKey;
            if (!isDigit && !isAllowedSpecial && !isShortcut) {
                e.preventDefault();
                return;
            }
        }
        if (e.key === 'Enter') {
            this.findByBarcode();
        }
    }

    searchProduct = (event) => {
        const barcode = this.state.product.barcode?.toString() || "";

        const query = (event.query && event.query.trim() !== "")
            ? event.query
            : (this.state.product.itemName || "");


        if (!barcode || barcode.length < 8) {
            setTimeout(() => {
                this.productService.searchCodedProductsByName(query).then(response => {

                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                        this.setState({
                            filteredProducts: [
                                {id: -1, longname: "New Product"},
                                ...response
                            ]
                        });
                    } else {
                        this.setState(
                            {
                                filteredProducts: [
                                    {id: -1, longname: "New Product"}
                                ]
                            },
                            () => {
                            }
                        );
                    }
                });
            }, 100);
        } else {
            this.setState({filteredProducts: []});
        }
    };


    getDeleteId() {
        return this.state.product?.id;
    }

    findByBarcode() {
        let product = this.state.product;
        if (product.barcodeIsSearched && !GeneralUtils.isNullOrEmpty(product.itemBssId)) {
            return toast.warn("Please use the Restore Item button to query again.");
        } else {
            if (!GeneralUtils.isNullOrEmpty(product.barcode)) {
                product["barcodeIsSearched"] = true;
                this.productService.findProductByBarcodeWithDepos(product.barcode)
                    .then(async (response) => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            this.refreshDepartmentListIfMissing(response.departmentId);
                            product["itemName"] = response.name;
                            product["itemBssId"] = response.bssId;
                            product["oldPrice"] = response.price;
                            product["currentBoxPrice"] = response.costPrice;
                            product["currentBoxSize"] = (response.boxQuantity != null && response.boxQuantity !== 0) ? response.boxQuantity : null;
                            product["status"] = "ACTIVE";
                            product["barcodeType"] = response.barcodeType;
                            product["barcodeDigit"] = response.barcodeDigit;
                            product["codeLength"] = response.codeLength;
                            product["profitMargin"] = response.profitMargin != null && response.profitMargin !== 0 && response.profitMargin !== 40
                                ? response.profitMargin
                                : (response.departmentProfitMargin != null && response.departmentProfitMargin !== 0 && response.departmentProfitMargin !== 40
                                    ? response.departmentProfitMargin
                                    : await this.getDefaultProfitMargin());

                            product["departmentId"] = response.departmentId;
                            product["taxRate"] = (response.taxRate ?? response.departmentTaxRate);
                            if (
                                GeneralUtils.isNullOrEmpty(product.id) ||
                                (
                                    !GeneralUtils.isNullOrEmpty(product.itemUnitMeasure) &&
                                    !GeneralUtils.isNullOrEmpty(product.itemSize) &&
                                    response.unit !== "each" &&
                                    response.quantity !== 1
                                )
                            ) {
                                product["itemUnitMeasure"] = response.unit;
                                product["itemSize"] = response.quantity;
                            }
                            if (response.minStock != null && response.minStock !== 0) {
                                product["minStock"] = response.minStock;
                            } else {
                                product["minStock"] = await this.getDefaultMinStock();
                            }

                            product["weighable"] = response.weighable;
                            if (response.boxQuantity != null && response.boxQuantity !== 0 && response.boxQuantity !== 1) {
                                product["boxSize"] = response.boxQuantity;
                            } else if (product["boxSize"] == null && response.boxQuantity != null) {
                                product["boxSize"] = response.boxQuantity;
                            }


                            product["boxPrice"] = response.boxPrice;
                            product["newCodedProduct"] = false;

                            if (response.maxStock != null && response.maxStock !== 0) {
                                product["maxStock"] = response.maxStock;
                                product["maxOrjStock"] = response.maxStock;
                            } else {
                                const deliveryQuantity = product.deliveryQuantity || 0;
                                const boxSize = product.boxSize || 0;
                                product["maxStock"] = deliveryQuantity * boxSize;
                                product["maxOrjStock"] = null;
                            }

                            const calculated = this.props.calculateFields?.(product) ?? product;
                            this.setState({product: calculated});
                            this.props.updatePurchaseOrderItemFieldsOnly?.(calculated);

                            this.stockActivityService.getCurrentStockOfProduct(response.bssId)
                                .then((response) => {
                                    if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                                        this.setState({
                                            currentStock: response,

                                        });
                                    }
                                });

                        } else {
                            product["itemBssId"] = null;
                            product["oldPrice"] = null;
                            product["currentBoxPrice"] = null;
                            product["currentBoxSize"] = null;
                            product["status"] = "ACTIVE";
                            product["profitMargin"] = await this.getDefaultProfitMargin();
                            product["barcodeIsSearched"] = true;
                            product["newCodedProduct"] = false;
                            product["barcodeType"] = "NORMAL";
                            product["barcodeDigit"] = null;
                            product["codeLength"] = null;
                            this.setState({
                                product: product,
                                currentStock: null
                            }, () => {
                                this.getDefaultData();
                            });

                            //return toast.warn("Barcode not Found!");
                        }
                    });
            }
        }


    }

    refreshDepartmentListIfMissing = (departmentId) => {
        if (GeneralUtils.isNullOrEmpty(departmentId)) {
            return;
        }
        const exists = (this.state.departmentList || []).some((department) => department.id === departmentId);
        if (!exists) {
            this.departmentService.findAll().then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({departmentList: response});
                }
            });
        }
    }

    saveProduct = async () => {
        let product = this.state.product;
        const selectedTax = this.state.taxList.find(t => t.rate === product.taxRate);

        const data = {
            name: product.itemName,
            barcode: product.barcode,
            tax: selectedTax ? selectedTax.id : null,
            weighable: product.weighable,
            profitMargin: product.profitMargin ?? await this.getDefaultProfitMargin(),
            quantity: product.itemSize,
            price: product.salePrice,
            unit: product.itemUnitMeasure,
            boxUnit: product.boxUnitMeasure,
            minStock: product.minStock,
            maxStock: product.maxStock,
            departmentId: product.departmentId,
            productType: 'PRODUCT_LINE',
            status: 'ACTIVE',
            boxQuantity: product.boxSize

        };


        return this.productService.create(data) // return eklendi
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response)) {
                    if (GeneralUtils.isNullOrEmpty(response.type)) {
                        let product = this.state.product;
                        product.itemBssId = response.bssId;
                        product.oldPrice = response.price;
                        product.currentBoxPrice = response.costPrice;
                        product.currentBoxSize = (response.boxQuantity != null && response.boxQuantity !== 0) ? response.boxQuantity : null;
                        this.setState({product});
                        return product;
                    } else {
                        toast.error("Error: " + response.type);
                        throw new Error(response.type);
                    }
                } else {
                    toast.error("Unknown error");
                    throw new Error("Unknown error");
                }
            })
            .catch((error) => {
                toast.error("Server Error: " + error.message);
                throw error;
            });
    };


    convertToDto = async (response) => {
        let product = this.state.product;
        product.itemName = response.name;
        product.itemBssId = response.bssId;
        product.barcode = response.barcode;
        product.itemSize = response.quantity;
        product.taxRate = (response.taxRate ?? response.departmentTaxRate);
        product.weighable = response.weighable;
        product.oldPrice = response.price;
        product.currentBoxPrice = response.costPrice;
        product.currentBoxSize = (response.boxQuantity != null && response.boxQuantity !== 0) ? response.boxQuantity : null;
        product.status = "ACTIVE";
        product.barcodeType = response.barcodeType;
        product.barcodeDigit = response.barcodeDigit;
        product.codeLength = response.codeLength;

        product.profitMargin = response.profitMargin ?? await this.getDefaultProfitMargin();
        product.itemUnitMeasure = response.unit;
        product.boxUnitMeasure = response.boxUnit;
        if (response.minStock != null && response.minStock !== 0) {
            product.minStock = response.minStock;
        } else {
            product.minStock = await this.getDefaultMinStock();
        }

        if (response.maxStock != null && response.maxStock !== 0) {
            product["maxStock"] = response.maxStock;
            product["maxOrjStock"] = response.maxStock;
        } else {
            const deliveryQuantity = product.deliveryQuantity || 0;
            const boxSize = product.boxSize || 0;
            product["maxStock"] = deliveryQuantity * boxSize;
            product["maxOrjStock"] = null;
        }


        product.departmentId = response.departmentId;
        product.barcodeIsSearched = true;
        product.newCodedProduct = false;

        this.stockActivityService.getCurrentStockOfProduct(response.bssId)
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    this.setState({
                        currentStock: response,

                    });
                }
            });

        this.setState({product: product});


    }

    __handleChangePrice = (e) => {
        const value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        const product = {...this.state.product};

        // 👇 Sadece kullanıcı manuel girdiyse işlem yap
        if (e.isManual && e.target.name === "salePrice") {
            product[e.target.name] = value;
            product.tillPriceCalculationMethod = "MANUAL_ENTRY";
            const calculated = this.props.calculateFields(product);
            this.setState({product: calculated});
        } else {
            product[e.target.name] = value;
            this.setState({product});
        }

    };

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let name = e.target.name;

        // Barcode alanında sadece rakam kabul et
        if (name === "barcode" && value != null) {
            value = value.toString().replace(/[^0-9]/g, '');
        }
        if (name === "profitMargin" && value !== null && value !== undefined && value !== '') {
            value = parseInt(value, 10);
            if (Number.isNaN(value)) {
                value = '';
            }
        }

        let updatedProduct = {...this.state.product};
        updatedProduct[name] = value;
        if (name === "barcodeType" && (value == "WEIGHT" || value == "PRICE")) {
            updatedProduct.codeLength = 7;
            updatedProduct.barcodeDigit = 5;
        }
        // Barkod değiştiyse bazı alanları sıfırla
        if (name === "barcode") {
            updatedProduct.barcodeIsSearched = false;
            updatedProduct.itemBssId = null;
            updatedProduct.newCodedProduct = false;
        }

        if (name == "barcode" && value.length < 12) {
            updatedProduct.barcodeType = 'NORMAL'
            updatedProduct.barcodeDigit = null;
            updatedProduct.codeLength = null;
        }

        if (name === "deliveryQuantity" || name === "boxSize") {
            if (updatedProduct.maxOrjStock == null) {
                const deliveryQuantity = updatedProduct.deliveryQuantity || 0;
                const boxSize = updatedProduct.boxSize || 0;
                updatedProduct.maxStock = deliveryQuantity * boxSize;
            }
        }


        // DepartmentId değiştiyse ve itemBssId boşsa
        if (name === "departmentId" && GeneralUtils.isNullOrEmpty(updatedProduct.itemBssId)) {
            const selectedDepartment = this.state.departmentList.find(d => d.id == value);

            if (selectedDepartment) {
                if (selectedDepartment.profitMargin != null) {
                    updatedProduct.profitMargin = selectedDepartment.profitMargin;
                }

                if (selectedDepartment.taxRate != null) {
                    const selectedTax = this.state.taxList.find(t => t.rate === selectedDepartment.taxRate);
                    if (selectedTax) {
                        updatedProduct.taxRate = selectedTax.rate;
                    }
                }
            }
        }

        const runFindByBarcode = name === "barcode" && value && value.toString().length === 13;
        this.setState(prevState => {
            const calculated = this.props.calculateFields(updatedProduct, name);
            return {product: calculated};
        }, () => {
            if (runFindByBarcode && this.state.product.barcode && this.state.product.barcode.toString().length === 13) {
                this.findByBarcode();
            }
        });


    };

    handleBarcodeSearchClick = () => {
        let product = {...this.state.product};
        this.setState({product}, () => this.findByBarcode());
    };

    handleResetItem = () => {
        let product = {...this.state.product};
        product.barcode = null;
        product.barcodeIsSearched = false;
        product.itemBssId = null;
        product.itemName = product.orjDescription || "";
        this.setState({product}, () => {
            let obj1 = {...this.state.product};
            obj1 = this.setExpiryDate(obj1);
            this.props.updatePurchaseOrderItem(obj1);
        });
    };

    generateNextBarcode = () => {
        this.productService.getNextBarcode().then(response => {
            if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                let product = this.state.product;
                product["barcode"] = response.barcode;
                this.setState({product: product});
            }

        });
    }

    getDefaultMinStock = () => {
        return this.merchantBranchSettingsService
            .findByBranchId(localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    return response.minStock ?? null; // response.minStock varsa al, yoksa null
                }
                return null;
            });
    };

    getDefaultProfitMargin = () => {
        return this.merchantBranchSettingsService
            .findByBranchId(localStorage.getItem("merchantBranchId"))
            .then((response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    return response.profitMargin ?? 40;
                }
                return 40;
            });
    };

    getDefaultData = () => {
        this.merchantBranchSettingsService.findByBranchId(localStorage.getItem("merchantBranchId"))
            .then(async (response) => {
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                    let product = this.state.product;
                    if (response.minStock != null) {
                        product["minStock"] = response.minStock;
                    } else {
                        product["minStock"] = null;
                    }

                    if (product.departmentId == null && response.departmentId != null) {
                        product["departmentId"] = response.departmentId;
                    }

                    const deliveryQuantity = product.deliveryQuantity || 0;
                    const boxSize = product.boxSize || 0;
                    product["maxStock"] = deliveryQuantity * boxSize;

                    this.setState({product: product});
                }
            });

    }

    showChangeStatusConfirmDialog = (value) => {
        this.setState({
            displayShowStatusConfirmDialog: true,
            noticeResponse: "Are you sure to remove item?",
            deleteId: value.id
        });
    }


}

PurchaseOrderItemSave.propTypes = {
    order: PropTypes.object
};
